import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  publishedTime?: string;
  modifiedTime?: string;
  articleTags?: string[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  publishedTime,
  modifiedTime,
  articleTags,
}: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} - 黑料社区网`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) setMeta('og:url', canonicalUrl, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (publishedTime) setMeta('article:published_time', publishedTime);
    if (modifiedTime) setMeta('article:modified_time', modifiedTime);
    if (articleTags && articleTags.length > 0) {
      articleTags.forEach((tag) => {
        const el = document.createElement('meta');
        el.setAttribute('property', 'article:tag');
        el.setAttribute('content', tag);
        document.head.appendChild(el);
      });
    }

    return () => {
      articleTags?.forEach((tag) => {
        const els = document.querySelectorAll(`meta[property="article:tag"][content="${tag}"]`);
        els.forEach((el) => el.remove());
      });
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, publishedTime, modifiedTime, articleTags]);

  return null;
}